import { render, staticRenderFns } from "./IPRtsrs.vue?vue&type=template&id=69753bd2"
import script from "./IPRtsrs.vue?vue&type=script&lang=js"
export * from "./IPRtsrs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports